import { Observable, ReplaySubject } from 'rxjs';
import { captureException } from '@sentry/angular';

export class LazyResolver<T> {
  public current: T | undefined = undefined;
  private subject = new ReplaySubject<T>();
  private resolvables: ((val: T | null) => void)[] = [];

  constructor(private resolver: () => Promise<T>) {
    this.reload();
  }

  async reload() {
    try {
      this.current = await this.resolver();
      for (const resolvable of this.resolvables) {
        resolvable(this.current);
      }
      this.subject.next(this.current);
    } catch (e) {
      captureException(e);
    }
  }

  update(val: T) {
    this.current = val;
    this.subject.next(val);
  }

  async get(): Promise<T> {
    if (this.current !== undefined) {
      return this.current;
    }

    return new Promise<T>((resolve, reject) => {
      this.resolvables.push((val) => {
        if (val) {
          resolve(val);
        } else {
          reject(new Error('unable to load'));
        }
      });
    });
  }

  observe(): Observable<T> {
    return this.subject.asObservable();
  }
}
